// Statute-of-limitations day counts and dates — ONE definition for the SOL
// Tracker page (pages/SOLTracker.js) and the Matter page's ⚖️ SOL section
// (pages/MatterDetail.js), so the two never disagree about the same entry.
//
// sol_date and incident_date are Postgres DATE columns holding the firm's
// day; node-pg sends them as UTC midnight ("…T00:00:00.000Z").
//   - Days until the SOL are FIRM calendar days (utils/todoDue.js
//     daysUntilDue: the firm's today, wherever the app is opened), as the
//     Daily Snapshot's SOL panel and the server (`sol_date - today`) count
//     them.  Both pages used date-fns differenceInDays(new Date(sol_date),
//     new Date()): elapsed 24-hour periods from UTC midnight, so the count was
//     a day short from 5 PM Pacific (an SOL due today read "Expired 1d ago").
//   - A date shows its own calendar day (parseDateOnly): `new Date(sol_date)`
//     showed it a day early in US time zones.
// (James, 2026-10-17/18; SOLTracker.firmDay.test.js, MatterDetail.solFirmDay.test.js.)

import { format } from 'date-fns'
import { parseDateOnly } from './format'
import { daysUntilDue } from './todoDue'

/** Firm calendar days until the entry's SOL (0 = today, negative = expired), or null with no readable date. */
export function solDaysLeft (entry, now = new Date()) {
  return daysUntilDue({ due_date: entry ? entry.sol_date : null }, now)
}

/** A DATE column value formatted on its own calendar day, or '' when missing or unreadable (date-fns throws on an Invalid Date). */
export function formatDateOnly (value, pattern) {
  if (!value) return ''
  const d = parseDateOnly(value)
  return d instanceof Date && !isNaN(d.getTime()) ? format(d, pattern) : ''
}
